import { Box, styled } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CompanySSOConnectionDetails } from './edit-company-sso.types';
import { CopyField } from '../../../../../../../redesign';

type SsoConnectionCopyFieldsProps = {
  connectionDetails: CompanySSOConnectionDetails;
  entityIdLabel: string;
  acsUrlLabel: string;
  relayStateLabel: string;
};

export const SsoConnectionCopyFields = ({
  connectionDetails,
  entityIdLabel,
  acsUrlLabel,
  relayStateLabel,
}: SsoConnectionCopyFieldsProps) => {
  const { t } = useTranslation('web-common');
  const copyLabel = t('copy-field.copy.label');
  const copiedLabel = t('copy-field.copied.label');

  return (
    <Fields>
      <CopyField
        label={entityIdLabel}
        value={connectionDetails.entityId}
        copyLabel={copyLabel}
        copiedLabel={copiedLabel}
      />
      <CopyField
        label={acsUrlLabel}
        value={connectionDetails.assertionConsumerServiceUrl}
        copyLabel={copyLabel}
        copiedLabel={copiedLabel}
      />
      <CopyField
        label={relayStateLabel}
        value={connectionDetails.relayState}
        copyLabel={copyLabel}
        copiedLabel={copiedLabel}
      />
    </Fields>
  );
};

const Fields = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(4),
  width: '100%',
}));
